const formatAplicaciones = (aplicaciones) => {
    if (!aplicaciones) return 'General';
    const aplicacionesArray = aplicaciones.split('; ');
    const grouped = {};
    aplicacionesArray.forEach((app) => {
        const [marca, ...rest] = app.split(' ');
        const model = rest.join(' ');
        if (!grouped[marca]) grouped[marca] = [];
        grouped[marca].push(model.trim());
    });
    return Object.keys(grouped)
        .map((marca) => `${marca} ${grouped[marca].join(', ')}`)
        .join(' / ');
};

export default formatAplicaciones;
